export default "__VITE_ASSET__DjgPLe$u__"